export default __webpack_public_path__ + "static/media/Rerebrace of the Sanguine Disciple (nm).9c111873.jpg";